﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';
import { satserReducer } from '../../Shared/Scripts/Store/Satser/Reducers';
import { UtstyrsstipendSatser } from '../Utilities/UtstyrsstipendSatserApi';

const rootReducer = combineReducers<VeilederUtstyrsstipendAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    satser: satserReducer,
    epiContext: (
        state: EpiContext<VeilederUtstyrsstipendDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederUtstyrsstipendDto>,
    ): EpiContext<VeilederUtstyrsstipendDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederUtstyrsstipendAppState = EpiAppStateMedSteg<VeilederUtstyrsstipendDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: UtstyrsstipendSatser | null;
};

export default function configureStore(): Store<VeilederUtstyrsstipendAppState> {
    const valgStateJson = window.localStorage.getItem('state');
    if (valgStateJson != null) {
        const savedState = JSON.parse(valgStateJson) as VeilederUtstyrsstipendAppState;
        return createStore(rootReducer, savedState, applyMiddleware(ReduxThunk));
    }
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
